module.exports = __webpack_public_path__ + "static/img/qm_back_header_bg03.57828a67.png";